









































































































































































































































import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Ax} from '@/utils';
import CBreadcrumbs from "../components/c-breadcrumbs.vue";
import {number} from "@amcharts/amcharts4/core";

interface BudgetIntegrationIdcExpensesData {
    tableFields: any[];
    region: any;
    regObj: any;
    curYear: number;
    curPeriod: any;
    years: any[];
    periodLst: any[];
    listOfVariants: any[];
    variant: string;
    variantObj: any;
    variantDataTotal:any;
    variantMessages: any[];
    regionVariants: any[];
    listRegs: any[];
    regVariant: any;
    curDataType: any;
    filteredDataTypeDict: any[];
}

export default Vue.extend({
    name: 'BudgetIntegrationIdcExpenses',
    components: {CBreadcrumbs},
    props: {
        reg: String,
        listPeriods: Array,
        listReg: Array,
        listVariants: Array,
        dataTypeDict: Array,
        userRegion: String,
        obl: String,
        accessLevel: {type: Number, required: false, default: 0}
    },
    data(): BudgetIntegrationIdcExpensesData {
        return {
            tableFields: [
                {
                    key: 'action',
                    label: ' ',
                    class: 'toggle-show'
                },
                {
                    key: 'kat',
                    label: 'КАТ',
                    class: 'toggle-show'
                },
                {
                    key: 'cls',
                    label: 'КЛ',
                    class: 'toggle-show'
                },
            ],
            region: null,
            regObj: null,
            curYear: 0,
            curPeriod: {},
            years: [],
            periodLst: [],
            listOfVariants: [],
            variant: '',
            variantObj: null,
            variantDataTotal: null,
            variantMessages: [],
            regionVariants: [],
            listRegs: [],
            regVariant: {},
            curDataType: null,
            filteredDataTypeDict: [],
        }
    },
    computed: {
    },
    async mounted() {
        // 1. Загружается список периодов
        await this.getPeriodLst();
        // 2. Загружается список регионов
        await this.loadRegions(this.curYear);
        // 3. Загружается список вариантов бюджета и определяется значение CurDataType
        const defaultDataType = await this.loadVariants(true);
        // 4. Загружается список Видов данных
        await this.loadDataTypes(defaultDataType);
        // 5. загружается список отправленных версий бюджета
        await this.updateData();
    },
    methods: {
        makeToast(variant: string, title: string, content: string) {
            (this as any).$bvToast.toast(content, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000
            });
        },

        async handlePeriodChange(newPeriod: { name: string, year: number }) {
            if (newPeriod) {
                this.curYear = newPeriod.year;
            }
            await this.loadRegions(this.curYear);
            await this.updateFilters();
        },

        async handleRegionChange() {
            await this.updateFilters();
        },

        async handleDataTypeChange() {
            await this.loadVariants();
        },

        async getPeriodLst() {
            await this.loadYears();
            this.periodLst = this.years
                .map((y: any) => Number(y))
                .filter((y: number) => !isNaN(y))
                .map((year: number) => ({name: `${year} - ${year + 2}`, year}));
            if (this.curYear) {
                this.curPeriod = this.periodLst.find(p => p.year === this.curYear) || {};
            }
        },

        async updateData() {
            if (!this.variantObj || !this.variantObj.value) {
                this.makeToast('warning', 'Нет данных', 'Не выбрана версия бюджета для обновления.');
                return;
            }

            try {
                const response = await fetch(`/api/idc/variant-messages?variant=${this.variantObj.value}`);
                const text = await response.text();
                if (text) {
                    this.variantMessages = JSON.parse(text);
                } else {
                    this.variantMessages = [];
                }
            } catch (error) {
                this.variantMessages = [];
                this.makeToast('danger', 'Ошибка запроса сообщений', error.toString());
            }
        },

        async sendData() {
            if (!this.variantObj || !this.variantObj.value) {
                this.makeToast('warning', 'Нет данных', 'Не выбрана версия бюджета для обновления.');
                return;
            }
            try {
                const response = await fetch(`/api/idc/data?variant=${this.variantObj.value}`);
                const text = await response.text();
                if (text) {
                    this.variantDataTotal = JSON.parse(text);
                    (this as any).$bvModal.show('sendDataModal');
                }
            } catch (error) {
                this.variantDataTotal = null;
                this.makeToast('danger', 'Ошибка запроса данных', error.toString());
            }
        },

        async confirmSendData() {
            if (!this.variantObj || !this.variantObj.value) {
                this.makeToast('warning', 'Нет данных', 'Не выбрана версия бюджета для отправки.');
                return;
            }
            try {
                const response = await fetch(`/api/idc/send?variant=${this.variantObj.value}`, {
                    method: 'POST',
                });
                if (response.ok) {
                    this.makeToast('success', 'Успешно', 'Данные успешно отправлены.');
                    await this.updateData();
                } else if (response.status === 500) {
                    const errorData = await response.json();
                    if (errorData.args && errorData.args[0] && errorData.args[0].value) {
                        this.makeToast('danger', 'Ошибка при отправке данных:'+errorData.key, errorData.args[0].value);
                    } else {
                        this.makeToast('danger', 'Ошибка', 'Произошла неизвестная ошибка сервера.');
                    }
                } else {
                    const errorText = await response.text();
                    this.makeToast('danger', 'Ошибка', errorText);
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка отправки', error.toString());
            } finally {
                (this as any).$bvModal.hide('sendDataModal');
            }
        },

        cancelSendData() {
            (this as any).$bvModal.hide('sendDataModal');
        },

        async updateFilters() {
            const defaultDataType = await this.loadVariants(true);
            await this.loadDataTypes(defaultDataType);
            await this.updateData()
        },

        async loadDataTypes(defaultDataType: any = null) {
            try {
                const params = new URLSearchParams();
                if (this.curYear) {
                    params.append('year', this.curYear.toString());
                }
                if (this.regObj && this.regObj.value) {
                    params.append('region', this.regObj.value);
                }

                const response = await fetch(`/api/idc/typevariant?${params.toString()}`);
                const data = await response.json();

                if (Array.isArray(data) && data.length > 0) {
                    this.filteredDataTypeDict = data.map(row => ({text: row.nameRu, value: row.code}));
                    if (defaultDataType) {
                        this.curDataType = this.filteredDataTypeDict.find(d => d.value === defaultDataType) || this.filteredDataTypeDict[0];
                    } else {
                        this.curDataType = this.filteredDataTypeDict[0];
                    }
                } else {
                    this.filteredDataTypeDict = [];
                    this.curDataType = null;
                }
            } catch (error) {
                this.filteredDataTypeDict = [];
                this.curDataType = null;
                this.makeToast('danger', 'Ошибка запроса видов данных', error.toString());
            }
        },

        async loadVariants(isInitialLoad = false) {
            try {
                const params = new URLSearchParams();
                if (this.curYear) {
                    params.append('year', this.curYear.toString());
                }
                if (this.regObj && this.regObj.value) {
                    params.append('region', this.regObj.value);
                }
                // На начальной загрузке не передаем datatype, чтобы получить вариант по умолчанию
                if (!isInitialLoad && this.curDataType && this.curDataType.value) {
                    params.append('datatype', this.curDataType.value);
                }

                const response = await fetch(`/api/idc/variant?${params.toString()}`);
                const data = await response.json();

                if (Array.isArray(data) && data.length > 0) {
                    this.listOfVariants = data.map(row => ({
                        text: row.nameRu,
                        value: row.variantUuid,
                        dataType: row.dataType
                    }));
                    this.variantObj = this.listOfVariants[0];

                    if (isInitialLoad && this.variantObj && this.variantObj.dataType) {
                        return this.variantObj.dataType;
                    }
                    await this.updateData()
                } else {
                    this.listOfVariants = [];
                    this.variantObj = null;
                }
            } catch (error) {
                this.listOfVariants = [];
                this.variantObj = null;
                this.makeToast('danger', 'Ошибка запроса версий бюджета', error.toString());
            }
            return null;
        },

        async loadYears() {
            try {
                const response = await fetch('/api/idc/years');
                const data = await response.json();
                if (Array.isArray(data) && data.length > 0) {
                    this.years = data;
                    this.curYear = data[0];
                } else {
                    this.years = [];
                    this.curYear = 0;
                    this.makeToast('danger', 'Ошибка', 'Не удалось загрузить список периодов: неверный формат данных.');
                }
            } catch (error) {
                this.years = [];
                this.curYear = 0;
                this.makeToast('danger', 'Ошибка запроса периода', error.toString());
            }
        },

        async loadRegions(curYear: any) {
            try {
                let params: string = ""
                if (curYear != null) {
                    params = '?year=' + curYear;
                }
                const response = await fetch('/api/idc/regions' + params);
                const data = await response.json();
                if (Array.isArray(data) && data.length > 0) {
                    this.listRegs = data.map(row => ({text: `${row.code} - ${row.nameRu}`, value: row.code}));
                    this.regObj = this.listRegs[0];
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса регионов', error.toString());
            }
        },

        uploadFile(id: number, type:number) {
            // alert("id="+id+" type= "+type);
            let uploadName = 'request.xml';
            if (type===2) uploadName='response.xml'
            const urls = `/api/idc/get-file?id=${id}&type=${type}`;
            Ax<Blob>(
                {
                    url: urls,
                    method: 'GET',
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${uploadName}`);
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(url);
                },
                (error) => {
                    this.makeToast('danger', 'Ошибка Загрузки', error.toString());
                },
            );
        },

        openFilterByRef(refName: any) {
            const drop = this.$refs.drop as any;
            if (drop) {
                drop.show(true);
            }
            const refItem = this.$refs[refName] as any;
            if (refItem && refItem.$el) {
                setTimeout(() => refItem.$el.focus(), 100);
            }
        }
    }
})
